import React, { useState } from 'react';
import Modal from 'react-minimal-modal';
import Select from 'react-select'
import { useHistory } from 'react-router-dom';

import './createCostCenterModal.scss';
import {SystemIcon} from '@workday/canvas-kit-react/icon';
import {xSmallIcon} from '@workday/canvas-system-icons-web';
import { reorganizations } from '../../../../data/organizations';

const CreateCostCenterModal = (props) => {
    const history = useHistory();
    const [selected, setSelected] = useState(null);

    const close = () => {
        setSelected(null);
        props.onChange();
    }

    const confirm = () => {
        if (!selected) return;
        history.push(`/createCostCenter?reorganization=${encodeURIComponent(selected.value)}`);
    }

    return (
        <Modal className='createPositionModal' open={props.isOpen} onOpenChange={(open) => { if (!open) close() }} hideIcon={true} position="center">
            <div className='iconWrapper'>
                <button className='icon' onClick={close} aria-label='Close'>
                    <SystemIcon
                        className='xIcon'
                        icon={xSmallIcon}
                        fill={"#505ADF"}
                    />
                </button>
            </div>
            <div className='content'>
                <h3>Create Cost Center</h3>
                <div className='hr'/>
                <div className='supOrgWrapper'>
                    <label htmlFor='createCostCenter-reorganization'>Reorganization</label>
                    <p className='ast' aria-hidden='true'>*</p>
                    <div className='selectWrapper'>
                        <Select
                            className='select'
                            inputId='createCostCenter-reorganization'
                            name='reorganization'
                            options={reorganizations}
                            value={selected}
                            onChange={setSelected}
                            maxMenuHeight={80}
                            required
                            aria-required='true'
                        />
                    </div>
                </div>
                <div className='hr'/>
                <div className='buttons'>
                    <button className='ok' onClick={confirm} disabled={!selected}>OK</button>
                    <button onClick={close} className='cancel'>Cancel</button>
                </div>
            </div>
        </Modal>
    )
}

export default CreateCostCenterModal;
